import * as _ from 'lodash';

import { finleyAssert } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { GetRequiredDataTapesForVerificationQueryGQLType } from '~/packages/manualDataTapeUploads/requests/requests.gql.generated';
import { DataTape } from '~/packages/manualDataTapeUploads/types';

export const extractDataTapeMapFromRequiredDataTapes = (
  data: GetRequiredDataTapesForVerificationQueryGQLType,
): {
  dataTapes: DataTape[];
  reportingDate: Util.FullDateStr | null;
} => {
  const dataTapeGroupings =
    data.getRequiredDataTapesForVerification.requiredDataTapesGroupings;

  // Set minimum reporting date to most recent of latest reporting dates
  const reportingDate =
    _.max(_.map(dataTapeGroupings, (group) => group.latestReportingDate)) ??
    null;

  finleyAssert(
    dataTapeGroupings.length === 1,
    'there should be only one grouping of required data tapes for verification',
  );

  const dataTapes: DataTape[] = [];
  dataTapeGroupings[0].requiredDataTapes.forEach((dataTape) => {
    dataTapes.push({ ...dataTape, fileType: 'csv' });
  });
  dataTapeGroupings[0].requiredXlsxTapes.forEach((xlsxTape) => {
    dataTapes.push({ ...xlsxTape, fileType: 'xlsx' });
  });

  return { dataTapes, reportingDate };
};
